import * as Actions from '../index';
import * as TYPES from '../actions';
import { listClasses } from '../../../api/queries'
import { API } from 'aws-amplify'

export const saveCourses = allCourses => {
    return {
        type: TYPES.COURSES_ALL_DATA,
        data: allCourses,
    };
};

export const saveCourseID = id => {
    return {
        type: TYPES.COURSES_PARTICULAR_ID,
        data: id,
    };
};

export const dispatchCourses = () => {
    return dispatch => {
        try {
            return API.graphql({ query: listClasses, authMode: 'API_KEY' }).then((result) => {
                dispatch(Actions.saveCourses(result.data.listClasses.items))
                return result
            })
        } catch (err) {
            console.log("Error in dispatch is ", err);
        }
    }
}

export const dispatchCourseID = (userData) => {
    return dispatch => {
        dispatch(Actions.saveCourseID(userData))
    }
}